import { render } from "./DiscoverView.vue?vue&type=template&id=5ff35a4c&scoped=true"
import script from "./DiscoverView.vue?vue&type=script&lang=js"
export * from "./DiscoverView.vue?vue&type=script&lang=js"

import "./DiscoverView.vue?vue&type=style&index=0&id=5ff35a4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff35a4c"]])

export default __exports__